export default class MobileMenu {
  init() {
    $('#tptnmobilemenu .toggler').on('click', function() {
      $(this).toggleClass('active');
      $('.mobile-menu').toggle();
    });
  }
}



// WEBPACK FOOTER //
// ./js/components/tptnmobilemenu.js